import feature1 from './images/features/feature_1.svg';
import feature2 from './images/features/feature_2.svg';
import feature3 from './images/features/feature_3.svg';
import feature4 from './images/features/feature_4.svg';

export default [
  {
    img: feature1,
    title: 'Increase conversion',
  },
  {
    img: feature2,
    title: 'Use intelligence',
  },
  {
    img: feature3,
    title: 'Reduce returns',
  },
  {
    img: feature4,
    title: 'Brilliant user experience',
  },
];
